module.exports = __webpack_public_path__ + "img/gerard.16a58f3b.jpg";